export const endpoints = {
    urls: {
        get: `/get/getData`,
        delete: `/delete/deleteData`,
        insert: `/insert/insertData`,
        login: `/site/login`,
        create: `/contenidos/create`,
        search: `/contenidos/search`,
        update: `/contenidos/update`,
        ubicaciones: `/ubicaciones/ubicacionesCreate`,
        cajasUbicacionesSet: `/ubicaciones/cajasUbicacionesSet`,
        getCajasDisponibles: `/cajas/getDisponibles`,
        getCuentaGenerica: `/cuentas/getCuentaGenerica`,
        createImagesMultiple: `/images/createMultiple`,
        createImages: `/images/create`,
        contenidos: `/contenidos/search`,
        contenidosSearch: `/contenidos/search`,
        cuentasCreate: `/cuentas/cuentasCreate`,
        cuentasUpdate: `/cuentas/cuentasUpdate`,
        contenidosMovement: `/contenidos/movement`,
        impresionEtiquetas: `/etiquetas/create?`,
        articulosGet: `/articulos/articulosGet`,
        articulosCreate: `/articulos/articulosCreate`,
        articulosUpdate: `/articulos/articulosUpdate`,
        articulosDelete: `/articulos/articulosDelete`,
        contenidosUpdate: `/contenidos/update`,
        contenidosCreate: `/contenidos/create`,
        contenidosBulkCreate: `/contenidos/createBulk`,
        spUpdate: `/sp/update`,
        getMovimientos: `/get/getTipoMovimientos`,
        dboxDashboard: `/get/dboxDashboard`,
        getLoadData: `/get/getLoadData`,
        setComprobantesDigitalizaciones: `/comprobantes/digitalizaciones`,
        getImages: `/images/get`,
        getComprobantes: `/comprobantes/get`,
        comprobantesPrint: `/comprobantes/print`,
        getNewPassword: `/usuarios/getNewPassword`,
        getTableStructure: `/site/getTableStructure`,
        comprobantesCreate: `/comprobantes/create`,
        comprobantesDelete: `/comprobantes/delete`,
        produccionGet: `/produccion/produccionGet`,
        produccionCreate: `/produccion/produccionCreate`,
        produccionCambioEstado: `/produccion/produccionCambioEstado`,
        searchCliente: `/contenidos/searchClient`,
        getLote: `/contenidos/getLote`,
        comprobantesMovimientos: `/comprobantes/movimientos`,
        comprobantesCtaCte: `/comprobantes/ctaCte`,
        estantesGet: `/estantes/estantesGet`,
        estantesSet: `/estantes/estantesSet`, 
        estadisticasGet: `/estadisticasProcesos/estadisticasGet`,
        estadisticasUpdateContador: `/estadisticasProcesos/estadisticasUpdateContador`,
        comprobantesGuarda: `/comprobantes/guarda`,
        articulosGetPrecio: `/articulos/getPrecio`,
        getEstadisticasCajas: `/cajas/getEstadisticas`,
        ocrPlantillasListar: `/ocr/plantillas/listar`,
        ocrPlantillasCrear: `/ocr/plantillas/crear`,
        ocrPlantillasActualizar: `/ocr/plantillas/actualizar`,
        ocrPlantillasEliminar: `/ocr/plantillas/eliminar`,
        ocrPlantillasGuardarCampos: `/ocr/plantillas/guardarCampos`,
        ocrPlantillasGuardarRegiones: `/ocr/plantillas/guardarRegiones`,
        ocrLotesListar: `/ocr/lotes/listar`,
        ocrLotesCrear: `/ocr/lotes/crear`,
        ocrLotesRegistrarDoc: `/ocr/lotes/registrarDocumento`,
        ocrLotesProcesar: `/ocr/lotes/procesar`,
        ocrLotesEstado: `/ocr/lotes/estado`,
        ocrLotesAnalizarImagen: `/ocr/lotes/analizarImagen`,
        ocrLotesAnalizarPorRegiones: `/ocr/lotes/analizarPorRegiones`,
        ocrResultadosPorLote: `/ocr/resultados/porLote`,
        ocrResultadosPorDocumento: `/ocr/resultados/porDocumento`,
        ocrResultadosCorregir: `/ocr/resultados/corregir`,
        ocrResultadosReprocesar: `/ocr/resultados/reprocesar`,
        ocrResultadosRevisarTodos: `/ocr/resultados/revisarTodos`,
        ocrResultadosExportar: `/ocr/resultados/exportar`,
        ocrMetadatosListar: `/ocr/plantillas/metadatos`,
        ocrPlantillasCuentas: `/ocr/plantillas/cuentas`,
        ocrAnalisisEstadisticas: `/ocr/analisis/estadisticas`,
        contenidosExportCsv: `/contenidos/exportCsvStream`,
        contenidosGetAllForExport: `/contenidos/getAllForExport`,
        contenidosExportXlsx: `/contenidos/exportXlsx`,
        contenidosCountXlsx: `/contenidos/countXlsx`,
        contenidosExportJson: `/contenidos/exportJson`,
        contenidosCajasSinContenidos: `/contenidos/cajasSinContenidos`,
    }
}